<template>
  <custom-callout
    ref="detail-ref"
    :border-color-hex="value.statusColor"
    class-main="mt-3 rounded"
    :controlled="true"
    :opened="value.isOpen"
    @click:open="$emit('on-open-close')"
  >
    <div class="row mr-md-0 align-items-center">
      <div class="col-12 col-md-2">
        <div class="d-flex flex-column color-black">
          <div
            class="mb-1 font-light badge badge-pill font-16 py-2 mt-2 w-90 mx-auto"
            :style="statusColorStyle"
          >
            {{ value.status | empty }}
          </div>
        </div>
        <div class="col-12">
          <span class="data-title d-block border-mobile">
            {{ value.requestType }}
          </span>
        </div>
        <div class="col-12">
          <strong>{{ value.requestNumber }}</strong>
        </div>
      </div>
      <div class="col-8 border-left py-2">
        <div class="row">
          <div class="col-4">
            <span class="data-title d-block border-mobile">Estudiante:</span>
            <span class="font-16 color-black">
              {{ value.studentName | empty }} - {{ value.studentSie | empty }}
            </span>
          </div>
          <div class="col-4 my-2">
            <span class="data-title d-block border-mobile">
              Fecha de Solicitud:
            </span>
            <span class="font-16 color-black">
              {{ value.requestedDate | date('DD/MM/YYYY') }}
            </span>
          </div>
          <div class="col-4 my-2">
            <span class="data-title d-block border-mobile">Disciplina:</span>
            <span class="font-16 color-black">
              {{ value.discipline | empty }}
            </span>
          </div>
          <div class="col-4 my-2">
            <span class="data-title d-block border-mobile">
              Proveedor Solicitante:
            </span>
            <span class="font-16 color-black">
              {{ value.provider | empty }}
            </span>
          </div>
          <div class="col-4 my-2">
            <span class="data-title d-block border-mobile">Especialista:</span>
            <span class="font-16 color-black">
              {{ value.specialist | empty }}
            </span>
          </div>
        </div>
      </div>
      <div class="col-2">
        <drop-down :items="actionItems" />
      </div>
    </div>
    <template #edition>
      <div class="p-2">
        <div class="bg-white rounded p-md-3 px-md-4">
          <custom-tab
            v-if="
              value.viewToDisplay === viewDisplayEnum.ADDITIONAL_INFORMATION ||
                value.viewToDisplay === viewDisplayEnum.DOCUMENTS ||
                value.viewToDisplay === viewDisplayEnum.HISTORY_REQUEST ||
                value.viewToDisplay === viewDisplayEnum.REVERT
            "
          >
            <custom-tab-item
              active
              lazy
              title="Información de Año Escolar Extendido"
              @click="() => $emit('on-open-additional-information')"
            >
              <additional-information :data="value" />
            </custom-tab-item>
            <custom-tab-item
              :active="value.viewToDisplay === viewDisplayEnum.DOCUMENTS"
              lazy
              title="Documentos"
              @click="() => $emit('on-open-documents')"
            >
              <div class="ml-2 ml-md-5 ml-sm-2 mr-4 pb-3">
                <div class="row mt-3">
                  <div class="col col-sm col-12 pt-2">
                    <em class="fas fa-file-search text-orange mr-1" />
                    <span class="color-gray-7 font-16 font-weight-bold">
                      Documentos
                    </span>
                  </div>
                </div>
                <div class="py-3 mr-md-0">
                  <div class="ml-2 ml-md-5 ml-sm-2 mr-4 pb-3">
                    <compensatory-service-documents
                      :academic-year-id="value.academicYearId"
                      :add-reject-doc-type="false"
                      :request-id="value.requestId"
                      :request-status-id="value.statusId"
                    />
                  </div>
                </div>
              </div>
            </custom-tab-item>
            <custom-tab-item
              :active="value.viewToDisplay === viewDisplayEnum.HISTORY_REQUEST"
              lazy
              title="Historial de Solicitud"
              @click="() => $emit('on-open-request-histories')"
            >
              <div class="ml-2 ml-md-5 ml-sm-2 mr-4 pb-3">
                <div class="row mt-3">
                  <div class="col col-sm col-12 pt-2">
                    <em class="fas fa-clock text-orange mr-1" />
                    <span class="color-gray-7 font-16 font-weight-bold">
                      Historial de Solicitud
                    </span>
                  </div>
                </div>
                <div class="py-3 mr-md-0">
                  <AeeRequestHistory :status="value.statusLogs" />
                </div>
              </div>
            </custom-tab-item>
            <custom-tab-item
              v-if="showRevertStatusTab"
              :active="value.viewToDisplay === viewDisplayEnum.REVERT"
              lazy
              title="Regresar Estatus Anterior"
            >
              <return-to-previous-status
                :data="value"
                @cancel="$emit('on-open-close')"
                @on-save="$emit('refresh')"
              />
            </custom-tab-item>
          </custom-tab>
          <div v-if="value.viewToDisplay === viewDisplayEnum.ACCEPT">
            <accept-request
              :value="value"
              @on-cancel="$emit('on-open-close')"
              @on-save="$emit('refresh')"
            />
          </div>
          <div v-if="value.viewToDisplay === viewDisplayEnum.REJECT">
            <reject-request
              :value="value"
              @on-cancel="$emit('on-open-close')"
              @on-save="$emit('refresh')"
            />
          </div>
          <div v-if="value.viewToDisplay === viewDisplayEnum.AEE_REQUEST">
            <Request
              :academic-year-id="value.academicYearId"
              :contract-id="value.contractId"
              :request="{
                requestId: value.requestId,
                requestDate: value.requestedDate,
                comments: value.comment,
              }"
              title="Solicitar Año Escolar Extendido"
              @cancel="onCancelAeeRequest"
              @saved="onSavedAeeRequest"
            />
          </div>
        </div>
      </div>
    </template>
  </custom-callout>
</template>

<script>
import CustomCallout from 'custom-callout';
import DropDown from 'dropdown';
import { CustomTab, CustomTabItem } from 'custom-tabs';
import AdditionalInformation from './AdditionalInformation.vue';
import AcceptRequest from './AcceptRequest.vue';
import RejectRequest from './RejectRequest.vue';
import CompensatoryServiceDocuments from '@/views/uspqrp/contract-management/components/tabs/CompensatoryServiceDocuments.vue';
import AeeRequestHistory from './AEERequestHistory.vue';
import Request from '@/views/uspqrp/contract-management/components/Request.vue';
import compensatoryRequestStatus from '@/utils/constants/compensatoryRequestStatus.js';
import ReturnToPreviousStatus from '@/views/uspqrp/contract-management/components/tabs/ReturnToPreviousStatus.vue';

import viewDisplay from '@/utils/constants/aeeViewDisplay';

export default {
  name: 'ResultRow',
  components: {
    CustomCallout,
    DropDown,
    CustomTab,
    CustomTabItem,
    AdditionalInformation,
    CompensatoryServiceDocuments,
    AcceptRequest,
    RejectRequest,
    AeeRequestHistory,
    Request,
    ReturnToPreviousStatus,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    documents: [],
  }),
  computed: {
    viewDisplayEnum() {
      return viewDisplay;
    },
    statusColorStyle() {
      if (this.value.statusColor) {
        return `background-color: ${this.value.statusColor}`;
      }
      return '';
    },
    canReturnStatus() {
      const hasPermission = this.userHasPermissions(
        'rempro.provider.aee.revertstatus'
      );

      return (
        hasPermission && this.value.statusId !== compensatoryRequestStatus.Nuevo
      );
    },
    showRevertStatusTab() {
      return this.value.viewToDisplay === this.viewDisplayEnum.REVERT;
    },
    actionItems() {
      return [
        {
          label: 'Ver Solicitud AEE',
          icon: 'fas fa-calendar-times color-green',
          click: () => this.$emit('on-open-additional-information'),
        },
        {
          label: 'Ver Documentos',
          icon: 'fas fa-file-search color-green',
          click: () => this.$emit('on-open-documents'),
        },
        {
          label: 'Solicitar Año Escolar Extendido',
          icon: 'fas fa-solid fa-calendar-arrow-down color-green',
          visible: this.value.statusId == compensatoryRequestStatus.Denegado,
          border: 'top',
          click: () => this.$emit('on-view-request-aee'),
        },
        {
          label: 'Aceptar',
          icon: 'fas fa-check-square color-green',
          border: 'top',
          visible:
            this.value.statusId == compensatoryRequestStatus.Sometido &&
            this.userHasPermissions('rempro.provider.aeedetermination'),
          click: () => this.$emit('on-show-accept'),
        },
        {
          label: 'Rechazar',
          icon: 'fas fa-times-square color-red',
          visible:
            this.value.statusId == compensatoryRequestStatus.Sometido &&
            this.userHasPermissions('rempro.provider.aeedetermination'),
          click: () => this.$emit('on-show-reject'),
        },
        {
          label: 'Regresar Estatus Anterior',
          icon: 'fas fa-undo color-green',
          visible: this.canReturnStatus,
          click: () => this.$emit('on-open-return-to-previous-status'),
        },
      ];
    },
  },
  methods: {
    onCancelAeeRequest() {
      this.value.isOpen = false;
    },
    onSavedAeeRequest() {
      this.$emit('refresh');
    },
  },
};
</script>
